import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Pagination').create(({ theme }) => ({
  root: {
    position: 'absolute',
    bottom: '12px',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  pagination: {
    '& .MuiPaginationItem-root': {
      color: '#fff',
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      },
      '&.Mui-selected': {
        backgroundColor: theme.colors.button.secondary.background,
        color: theme.colors.text.primary,
        // '&:hover': {
        //   backgroundColor: theme.colors.background.secondary,
        // },
      },
    },
    '& .MuiPaginationItem-icon': {
      color: '#fff',
    },
  },
}))
